/*STATS*/

import { BriefcaseBusiness, FolderKanban, Code2, Layers3 } from "lucide-react";

const stats = [
  {
    icon: <BriefcaseBusiness size={22} />,
    value: 5,
    suffix: "+",
    label: "Years of Experience",
    isCounter: true,
  },
  {
    icon: <FolderKanban size={22} />,
    value: 8,
    suffix: "+",
    label: "Projects Completed",
    isCounter: true,
  },
  {
    icon: <Code2 size={22} />,
    value: 20,
    suffix: "+",
    label: "Technologies",
    isCounter: true,
  },
  {
    icon: <Layers3 size={22} />,
    value: "Specialization",
    label: "Backend • Frontend",
    isCounter: false,
  },
];

export default stats;
